import { z } from "zod";

/**
 * Creates a Zod schema for field messages that validates keys against a data schema.
 * Runtime validation ensures only valid field keys are accepted.
 */
export function createFieldMessagesSchema<T extends z.ZodRawShape>(dataSchema: z.ZodObject<T>) {
  const validKeys = Object.keys(dataSchema.shape);

  return z.record(z.string(), z.string()).refine((obj) => Object.keys(obj).every((key) => validKeys.includes(key)), {
    message: "Invalid field key in messages",
  });
}
